/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Signed_Id_InvalidInputs */

const es_co2_error_signed_id_invalid = /** @type {(inputs: Error_Signed_Id_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El archivo indicado no es válido.`)
};

/**

* @param {Error_Signed_Id_InvalidInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_signed_id_invalid = /** @type {((inputs?: Error_Signed_Id_InvalidInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Signed_Id_InvalidInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_signed_id_invalid(inputs)
});